export default "__VITE_ASSET___cRlsFIM__"